import {ChangeEvent as ReactChangeEvent, FC, useCallback} from "react";
import styled from "styled-components";
import {AutoResizeTextarea} from "./AutoResizeTextarea";

const AttribValueInputBase = styled.label`
    width: auto;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    margin: 0 0 2em 0;
    gap: 1em;
`;
const AttribName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    min-width: 7.5em;
`;
const InputBase = styled(AutoResizeTextarea)`
    min-width: 30em;
    min-height: 1em;
    
    margin: 0;
`;

export type AttribValueInputProps = {
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
};

export const AttribValueInput: FC<AttribValueInputProps> = ({name, value, onChange}) => {
  const onValueChange = useCallback(
    ({
       target: {
         value = '',
       },
     }: ReactChangeEvent<HTMLTextAreaElement>) => {
      onChange(name, value);
    },
    [name, onChange]
  );

  return (
    <AttribValueInputBase>
      <AttribName>
        {name}:
      </AttribName>
      <InputBase
        className="small"
        value={value}
        onChange={onValueChange}
      />
    </AttribValueInputBase>
  );
};
